import { Product } from './types'

export const initialProducts: Product[] = [
  {
    id: '1',
    name: 'Napuhanac Minions',
    dimensions: '5 x 5 x 3,5 m',
    usageTerms: `Korištenje isključivo bez obuće.
Djeca moraju biti pod stalnim nadzorom odrasle osobe tijekom cijelog korištenja.
Djeca različite dobi i veličine ne smiju koristiti napuhanac istovremeno kako ne bi došlo do ozljeda manje djece.
Zabranjeno je grubo ponašanje, guranje, hrvanje, salto, penjanje, vješanje po mrežama i sjedenje na bočnim stranama („zidovima“).
Zabranjeno je spuštanje niz tobogan glavom prema dolje.
Zabranjeno je zadržavanje djece na izlazu s tobogana.
Zabranjeno unošenje hrane, pića i oštrih predmeta u napuhanac.`,
    application: 'Unutarnji i vanjski prostor',
    basePrice: 90,
    deliveryPrice: 60,
    image:
      'https://cdn.magicpatterns.com/uploads/spCZoxS6xDvhHFCXe1ab23/IMG_2597.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/sfyGwQWA1eocXohctd9Lkr/IMG_2598.jpg',
      'https://cdn.magicpatterns.com/uploads/gLxCPFc4CgRCEknrg8Y6YF/IMG_2599.jpg',
    ],
    category: 'Napuhanci',
  },
  {
    id: '2',
    name: 'Napuhanac PAW PATROL',
    dimensions: '2,9 x 2,1 x 1,4 m',
    usageTerms: `Korištenje isključivo bez obuće.
Djeca moraju biti pod stalnim nadzorom odrasle osobe tijekom cijelog korištenja.
Nije dozvoljeno penjanje, vješanje po mrežama ni sjedenje na bočnim stranama („zidovima“).
Zabranjeno unošenje hrane, pića i oštrih predmeta u napuhanac.
Ograničite broj korisnika kako bi svako dijete imalo dovoljno prostora za sigurnu igru.`,
    application: 'Unutarnji i vanjski prostor',
    basePrice: 60,
    deliveryPrice: 20,
    image:
      'https://cdn.magicpatterns.com/uploads/u2TAvHTC6ZRwJtwhQ7APbB/20260422_143437.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/pyBZ9MpiQYeb9BT9Z89ZMe/20260422_143442.jpg',
      'https://cdn.magicpatterns.com/uploads/ntoroJebn9J51cFNNy1ANZ/20260422_143454.jpg',
    ],
    category: 'Napuhanci',
  },
  {
    id: '3',
    name: 'Mali napuhanac s lopticama ili bez loptica',
    description:
      'Dvorac na napuhavanje s više zona za igru, skakanje, košarka, penjanje, tobogan, mogućnost bazena s vodom ili lopticama.',
    dimensions: '364 x 315 x 239 cm',
    ageRestriction: 'Nije prikladno za djecu mlađu od 2 godine',
    capacity: '135 kg',
    application: 'Unutarnji i vanjski prostor',
    basePrice: 40,
    variants: [
      { label: 'Bez loptica', price: 40 },
      { label: 'Sa 500 loptica', price: 50 },
    ],
    deliveryPrice: 20,
    image:
      'https://cdn.magicpatterns.com/uploads/mx5zYRydBAAB3s6e9oVSDT/IMG_2594.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/8emjfZE3uKW4TwF4L7N6cD/IMG_2591.jpg',
      'https://cdn.magicpatterns.com/uploads/mVVcp5dGvccJ9oXD4awY5d/IMG_2592.jpg',
    ],
    category: 'Napuhanci',
  },
  {
    id: '4',
    name: 'Bijeli napuhanac dvorac s toboganom',
    dimensions: '4 x 2 x 2,5 m',
    ageRestriction: 'Nije prikladno za djecu mlađu od 3 godine',
    usageTerms: `Zabranjeno korištenje napuhanca u obući.
Zabranjeno je penjanje po vanjskim zidovima i mrežama napuhanca.
Zabranjeno izvođenje salta, grubog skakanja i guranja druge djece.
Djeca različite dobi i veličine ne smiju koristiti napuhanac istovremeno ako postoji opasnost od ozljede.
Zabranjeno unošenje hrane, pića i oštrih predmeta u napuhanac.`,
    application: 'Unutarnji i vanjski prostor',
    basePrice: 70,
    variants: [
      { label: 'Bez loptica', price: 70 },
      { label: 'Sa 500 loptica', price: 80 },
    ],
    deliveryPrice: 20,
    image:
      'https://cdn.magicpatterns.com/uploads/gJhqA9DFvia5ZNg5VYnQV9/IMG_2610.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/qedruvtXS2aTZJubhhcLxK/IMG_2612.jpg',
      'https://cdn.magicpatterns.com/uploads/h7FPGVVfLxpVBbU3k7hB2e/IMG_2607.jpg',
    ],
    category: 'Napuhanci',
  },
  {
    id: '5',
    name: 'Napuhanac balon',
    dimensions: '4 x 1 x 2 m',
    ageRestriction: 'Predviđeno za sve uzraste',
    usageTerms: `Ulazak dozvoljen isključivo bez obuće.
Korištenje je dozvoljeno isključivo uz nadzor odrasle osobe.
Zabranjeno je unošenje oštrih predmeta zbog mogućnosti oštećenja napuhanca i pucanja balona.
Baloni nisu namijenjeni za gutanje ili trganje.
U slučaju pucanja balona, ostatke je potrebno odmah ukloniti zbog sigurnosti djece.
Zabranjeno je grubo ponašanje i naguravanje unutar balon napuhanca.`,
    application: 'Unutarnji i vanjski prostor',
    basePrice: 80,
    variants: [
      { label: 'Bez balona', price: 80 },
      { label: 'Sa 50 balona', price: 90 },
      { label: 'Sa 100 balona', price: 100 },
    ],
    deliveryPrice: 20,
    image:
      'https://cdn.magicpatterns.com/uploads/84f3zNpGWm7orR1WVDFXtG/IMG_2646.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/m33yP687UDi8JcyBc4MmtM/DJI_0721.jpg',
    ],
    category: 'Napuhanci',
  },
  {
    id: '6',
    name: 'Soft Play igraonica',
    description: 'Baloni i loptice uključeni u cijenu.',
    usageTerms: `Korištenje isključivo bez obuće.
Djeca moraju biti pod stalnim nadzorom odrasle osobe tijekom cijelog korištenja.
Zabranjeno je grubo ponašanje, guranje i bacanje elemenata soft play igraonice.
Zabranjeno je penjanje po zaštitnim dijelovima i ogradama.
Zabranjeno je unošenje hrane, pića, žvakaćih guma, šljokica i face paintinga u prostor igraonice.
Zabranjeno je unošenje oštrih predmeta, ukosnica, igli i predmeta koji mogu oštetiti opremu.`,
    application: 'Unutarnji i vanjski prostor',
    basePrice: 250,
    variants: [
      { label: 'Opcija 3: soft play i 2 guralice', price: 250 },
      { label: 'Opcija 2: 1 napuhanac i 2 guralice', price: 290 },
      { label: 'Opcija 1: 2 napuhanca i 2 guralice', price: 350 },
    ],
    deliveryPrice: 20,
    image:
      'https://cdn.magicpatterns.com/uploads/nu7mhRsXNCSMpUie16i1i9/IMG-20260429-WA0017(1).jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/1n1rRYCuqbXHVpo3AwFUFk/20260429_213701.jpg',
      'https://cdn.magicpatterns.com/uploads/d2VSci4iLFVMqtaCKn86zP/IMG-20260704-WA0003.jpg',
      'https://cdn.magicpatterns.com/uploads/wDngUuSDXGAEDSSrfZ6h4b/IMG-20260704-WA0004.jpg',
      'https://cdn.magicpatterns.com/uploads/rKMjtunL3nfNNsM6ujsmoN/IMG-20260704-WA0006.jpg',
    ],
    category: 'Soft Play',
  },
  {
    id: '7',
    name: 'Nogopikado za odrasle',
    description: 'Uključena dva seta lopti, svaki set ima 3 lopte.',
    dimensions: '1,5 x 3 x 3 m',
    application: 'Unutarnji i vanjski prostor',
    basePrice: 50,
    deliveryPrice: 0,
    image:
      'https://cdn.magicpatterns.com/uploads/jtBqe1tpecpiLZGEBRkUzy/IMG_2661.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/6yfP85NH7PfTKD5uVtB9zc/IMG_2671.jpg',
    ],
    category: 'Sport',
  },
  {
    id: '8',
    name: 'Nogopikado za djecu',
    description: 'Uključena dva seta lopti, svaki set ima 3 lopte.',
    dimensions: '1,5 x 1,5 x 1,5 m',
    application: 'Unutarnji i vanjski prostor',
    basePrice: 30,
    deliveryPrice: 0,
    image:
      'https://cdn.magicpatterns.com/uploads/ntMCRtHi8ighREkuVbh977/IMG_2688.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/1o9XVRmh1YeYajPribraBo/IMG_2690.jpg',
    ],
    category: 'Sport',
  },
  {
    id: '9',
    name: 'Dodatni set lopti',
    description: '3 komada',
    application: 'Unutarnji i vanjski prostor',
    basePrice: 10,
    deliveryPrice: 0,
    image:
      'https://cdn.magicpatterns.com/uploads/gnLP5MFdxwR7ZVaqQTFqnz/IMG_2693.jpg',
    category: 'Dodaci',
  },
  {
    id: '12',
    name: 'Napuhani pikado',
    description:
      'Zabavna natjecateljska igra za djecu i odrasle — savršen dodatak rođendanima, proslavama i drugim događanjima.',
    dimensions: '3 x 3 m',
    application: 'Unutarnji i vanjski prostor',
    basePrice: 70,
    deliveryPrice: 0,
    image:
      'https://cdn.magicpatterns.com/uploads/3uSUMgZC2QGEpZ69RuyNZj/20260710_190322.jpg',
    category: 'Sport',
  },
]
